import React from 'react';
import { Button } from '@hub/button';
import { ClearInvertedSmallIcon } from '@hub/icon';
import { jsx as _jsx } from "react/jsx-runtime";
const ClearButton = _ref => {
  let {
    query,
    clearQuery
  } = _ref;
  if (!query) {
    return null;
  }
  return /*#__PURE__*/_jsx(Button, {
    "aria-label": "Clear search text",
    type: "button",
    variant: 'transparent',
    rightIcon: /*#__PURE__*/_jsx(ClearInvertedSmallIcon, {
      sx: {
        cursor: 'pointer',
        position: 'absolute',
        width: 'size-icon-sm',
        height: 'size-icon-sm',
        top: 'spacing-sm',
        left: 'spacing-md',
        color: 'licorice'
      },
      "data-id": "search-modal-autocomplete_clear-button_ClearButton_ClearInvertedSmallIcon"
    }),
    onClick: e => {
      e.preventDefault();
      clearQuery();
    },
    "data-id": "search-modal-autocomplete_clear-button_ClearButton_Button"
  });
};
export default ClearButton;